exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group .input-group-text[data-v-66060836] {\n  background-color: transparent;\n}\n.input-group .form-control[data-v-66060836] {\n  border-left: 0;\n}\nth[data-v-66060836] {\n  font-size: 12px;\n}", ""]);

// exports
